import { Col, Container, Row } from 'nhsuk-react-components';
import { signInWithRedirect } from 'aws-amplify/auth';
import BlueCircles from '../BlueCircles';
import AdditionalResources from './AdditionalResources';
import './MainContent.scss';
import SPIInformation from './SPIInformation';

function LandingPage() {
  return (
    <main id="maincontent" aria-label="SPI landing page main content" className="landing-page">
      <Container fluid className="nhsuk-u-margin-0">
        <Row className="landing-page__row-container nhsuk-u-padding-0 nhsuk-u-margin-0">
          <Col
            width="one-half"
            className="landing-page__text-container"
          >
            <SPIInformation onLogin={() => signInWithRedirect()} />
            <AdditionalResources />
          </Col>
          <Col
            width="one-half"
            className="landing-page__mobile-hidden nhsuk-u-padding-0 nhsuk-u-margin-0"
            aria-hidden="true"
          >
            <div className="svg-column">
              <BlueCircles />
            </div>
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default LandingPage;
